(function () {
  'use strict';

  var ROOT_CLASS = 'reveal-animation';

  if (!document.documentElement.classList.contains(ROOT_CLASS)) return;

  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  var SECTION_SCOPE = 'main .shopify-section, footer .shopify-section';

  var CANDIDATE_SELECTOR = [
    '.js-reveal',
    '.js-reveal-children',
    '.section-header',
    '.template-header',
    '.section-block',
    '.banner__box',
    '.grid-item',
    '.grid__item',
    '.card-wrapper',
    '.article-card',
    '.multicolumn__item',
    '.contacts__item',
    '.social-grid__item',
    '.image-grid__item',
    '.icons_with_text__item',
    '.text-block__item',
    '.related-collections__item',
    '.slider__grid-item',
    '.banner-grid__card',
    '.banner-with-product__product',
    '.footer__block'
  ].join(',');

  var SECTION_OVERRIDES = [
    { match: '.collapsible-tabs', select: '.accordion, .collapsible-tabs__button' }
  ];

  var HARD_SKIP = [
    'dialog',
    '[role="dialog"]',
    '.modal',
    '.drawer',
    '.cart-drawer',
    'cart-drawer',
    '.popup',
    '.newsletter-popup',
    '.search-modal',
    'predictive-search',
    '.mega-menu',
    'quick-view',
    '.quick-view',
    '.overlay'
  ].join(',');

  var ROW_THRESHOLD = 40;
  var MAX_STAGGER_STEPS = 12;

  var observer = null;

  function prefersReducedMotion() {
    return motionQuery.matches;
  }

  function isSkipped(el) {
    if (el.closest(HARD_SKIP)) return true;

    var soft = el.closest('[data-reveal-skip]');
    if (!soft) return false;

    var marker = el.closest('.js-reveal, .js-reveal-children');
    if (marker && marker !== soft && soft.contains(marker)) return false;

    return true;
  }

  function isVisible(el) {
    return el.offsetParent !== null || el.getClientRects().length > 0;
  }

  function collectItems(section) {
    var selector = CANDIDATE_SELECTOR;
    for (var s = 0; s < SECTION_OVERRIDES.length; s++) {
      if (section.querySelector(SECTION_OVERRIDES[s].match)) {
        selector += ',' + SECTION_OVERRIDES[s].select;
      }
    }

    var all = Array.prototype.slice
      .call(section.querySelectorAll(selector))
      .filter(function (el) {
        return !isSkipped(el) && isVisible(el);
      });

    var candidateSet = new Set(all);
    var topMost = all.filter(function (el) {
      var parent = el.parentElement;
      while (parent && parent !== section) {
        if (candidateSet.has(parent)) return false;
        parent = parent.parentElement;
      }
      return true;
    });

    if (topMost.length === 0) {
      var fallback = section.querySelector('.section-container') || section.firstElementChild;
      if (fallback && !isSkipped(fallback)) topMost = [fallback];
    }

    var expanded = [];
    topMost.forEach(function (el) {
      Array.prototype.push.apply(expanded, expandUnit(el));
    });

    return expanded;
  }

  function topMostMarkers(root) {
    var all = Array.prototype.slice.call(root.querySelectorAll('.js-reveal, .js-reveal-children'));
    return all.filter(function (c) {
      return !all.some(function (other) { return other !== c && other.contains(c); });
    });
  }

  function childrenUnits(container) {
    var out = [];
    Array.prototype.slice.call(container.children).forEach(function (child) {
      if (isSkipped(child) || !isVisible(child)) return;
      Array.prototype.push.apply(out, expandUnit(child));
    });
    return out;
  }

  function expandUnit(el) {
    if (!el.matches) return [el];

    if (el.matches('.js-reveal-children')) {
      var u = childrenUnits(el);
      return u.length ? u : [el];
    }

    if (el.matches('.section-header, .template-header')) {
      var kids = Array.prototype.slice.call(el.children).filter(function (kid) {
        return !isSkipped(kid) && isVisible(kid);
      });
      if (kids.length > 1) {
        var headerUnits = [];
        kids.forEach(function (kid) { Array.prototype.push.apply(headerUnits, expandUnit(kid)); });
        return headerUnits.length ? headerUnits : [el];
      }
    }

    var nested = topMostMarkers(el);
    if (nested.length) {
      var drilled = [];
      nested.forEach(function (marker) { Array.prototype.push.apply(drilled, expandUnit(marker)); });
      return drilled.length ? drilled : [el];
    }

    return [el];
  }

  function prepareSection(section) {
    collectItems(section).forEach(function (el) {
      if (el.classList.contains('reveal-item')) return;
      el.classList.add('reveal-item');

      if (prefersReducedMotion() || !observer) {
        el.classList.add('is-in-view');
        return;
      }
      observer.observe(el);
    });
  }

  function watchAsyncLoaders() {
    if (!('MutationObserver' in window)) return;

    document.querySelectorAll('main product-recommendations, footer product-recommendations').forEach(function (loader) {
      var section = loader.closest('.shopify-section');
      if (!section) return;

      var timer = null;
      var mo = new MutationObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          prepareSection(section);
        }, 50);
      });
      mo.observe(loader, { childList: true });
    });
  }

  function revealFresh(items, container) {
    if (!items.length) return;

    if (prefersReducedMotion()) {
      items.forEach(function (el) {
        el.classList.add('reveal-item');
        el.classList.add('is-in-view');
      });
      return;
    }

    items.forEach(function (el) {
      el.style.transition = 'none';
      el.classList.add('reveal-item');
      el.classList.remove('is-in-view');
      if (observer) observer.unobserve(el);
    });
    void (container || document.documentElement).offsetWidth;
    items.forEach(function (el) {
      el.style.transition = '';
    });

    revealBatch(items);
  }

  function revealPanel(panel) {
    if (panel.matches && panel.matches('.js-reveal')) {
      revealFresh([panel], panel);
    } else {
      revealFresh(collectItems(panel), panel);
    }
  }

  function watchTabs() {
    if (!('MutationObserver' in window)) return;

    document.querySelectorAll('main .component-tabs__content, footer .component-tabs__content').forEach(function (panel) {
      var wasActive = panel.classList.contains('active');
      var mo = new MutationObserver(function () {
        var isActive = panel.classList.contains('active');
        if (isActive && !wasActive) revealPanel(panel);
        wasActive = isActive;
      });
      mo.observe(panel, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function dynamicSections() {
    var sections = [];
    document.querySelectorAll(
      'main [id^="product-grid--"], main product-recommendations,' +
      'footer [id^="product-grid--"], footer product-recommendations'
    ).forEach(function (el) {
      var section = el.closest('.shopify-section');
      if (section && sections.indexOf(section) === -1) sections.push(section);
    });
    return sections;
  }

  function hideNewItems() {
    dynamicSections().forEach(function (section) {
      collectItems(section).forEach(function (el) {
        if (!el.classList.contains('reveal-item') && !el.classList.contains('is-in-view')) {
          el.classList.add('reveal-item');
        }
      });
    });
  }

  function revealScope() {
    dynamicSections().forEach(function (section) {
      var toAnimate = [];

      collectItems(section).forEach(function (el) {
        if (el.classList.contains('is-in-view')) return;

        var rect = el.getBoundingClientRect();
        var inView = rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;

        if (inView) {
          toAnimate.push(el);
        } else {
          el.classList.add('reveal-item');
          if (observer) observer.observe(el);
        }
      });

      if (toAnimate.length) revealFresh(toAnimate, section);
    });
  }

  var dynamicTimer = null;

  function onDynamicUpdate() {
    hideNewItems();
    document.documentElement.classList.remove('reveal-grid-updating');
    window.clearTimeout(dynamicTimer);
    dynamicTimer = window.setTimeout(revealScope, 50);
  }

  var switchingFailsafe = null;

  function markGridSwitching(event) {
    if (prefersReducedMotion()) return;
    if (!event.target.closest || !event.target.closest('grid-switcher, .grid-switcher, .grid-switcher__option')) return;

    document.documentElement.classList.add('reveal-grid-updating');
    window.clearTimeout(switchingFailsafe);
    switchingFailsafe = window.setTimeout(function () {
      document.documentElement.classList.remove('reveal-grid-updating');
    }, 2000);
  }

  function watchDynamicUpdates() {
    document.addEventListener('filters-ajax-page-load', onDynamicUpdate);
    document.addEventListener('ajax-page-load', onDynamicUpdate);
    document.addEventListener('recommendations:loaded', onDynamicUpdate);

    document.addEventListener('click', markGridSwitching, true);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') markGridSwitching(event);
    }, true);

    if (!('MutationObserver' in window)) return;

    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) {
          onDynamicUpdate();
          return;
        }
      }
    });

    document.querySelectorAll('main, footer').forEach(function (root) {
      mo.observe(root, { childList: true });
    });
  }

  function revealBatch(elements) {
    var groups = [];
    var bySection = [];
    elements.forEach(function (el) {
      var section = el.closest('.shopify-section') || document.body;
      var idx = groups.indexOf(section);
      if (idx === -1) { groups.push(section); bySection.push([el]); }
      else { bySection[idx].push(el); }
    });

    groups.forEach(function (section, gi) {
      var rankOf = sectionRankMap(section);
      var min = Infinity;
      bySection[gi].forEach(function (el) {
        var r = rankOf.get(el);
        if (r != null && r < min) min = r;
      });
      if (min === Infinity) min = 0;

      bySection[gi].forEach(function (el) {
        var r = rankOf.get(el);
        if (r == null) r = min;
        el.style.setProperty('--reveal-order', Math.min(r - min, MAX_STAGGER_STEPS));
      });
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        elements.forEach(function (el) {
          el.classList.add('is-in-view');
        });
      });
    });
  }

  function sectionRankMap(section) {
    var ranked = Array.prototype.slice.call(section.querySelectorAll('.reveal-item'))
      .map(function (el) {
        var rect = el.getBoundingClientRect();
        return { el: el, top: rect.top, left: rect.left };
      })
      .sort(function (a, b) {
        if (Math.abs(a.top - b.top) > ROW_THRESHOLD) return a.top - b.top;
        return a.left - b.left;
      });

    var map = new Map();
    ranked.forEach(function (item, i) { map.set(item.el, i); });
    return map;
  }

  var pendingReveal = [];
  var revealFlushTimer = null;

  function handleIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      pendingReveal.push(entry.target);
      observer.unobserve(entry.target);
    });

    if (!pendingReveal.length || revealFlushTimer !== null) return;

    revealFlushTimer = window.setTimeout(function () {
      var batch = pendingReveal;
      pendingReveal = [];
      revealFlushTimer = null;
      revealBatch(batch);
    }, 50);
  }

  function forceRevealPending() {
    document.querySelectorAll('.reveal-item:not(.is-in-view)').forEach(function (el) {
      el.classList.add('is-in-view');
    });
  }

  function revealStuckNearViewport() {
    var stuck = document.querySelectorAll('.reveal-item:not(.is-in-view)');
    if (!stuck.length) return;

    var batch = [];
    var vh = window.innerHeight;
    stuck.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < vh + 48 && rect.bottom > -48) {
        if (observer) observer.unobserve(el);
        batch.push(el);
      }
    });
    if (batch.length) revealBatch(batch);
  }

  function isNearPageBottom() {
    var scrollBottom = window.scrollY + window.innerHeight;
    var docHeight = Math.max(
      document.body ? document.body.scrollHeight : 0,
      document.documentElement.scrollHeight
    );
    return docHeight - scrollBottom < 160;
  }

  function watchPageEnd() {
    var ticking = false;
    function check() {
      ticking = false;
      if (!isNearPageBottom()) return;
      revealStuckNearViewport();
    }
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    requestAnimationFrame(function () {
      requestAnimationFrame(check);
    });
  }

  function init() {
    if (prefersReducedMotion()) {
      document.querySelectorAll(SECTION_SCOPE).forEach(prepareSection);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll(SECTION_SCOPE).forEach(prepareSection);
      forceRevealPending();
      return;
    }

    observer = new IntersectionObserver(handleIntersect, {
      rootMargin: '0px 0px -40px 0px',
      threshold: 0
    });

    document.querySelectorAll(SECTION_SCOPE).forEach(prepareSection);

    watchAsyncLoaders();

    watchTabs();

    watchDynamicUpdates();

    watchPageEnd();

    void document.documentElement.offsetHeight;

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.shopify-section') || event.target.closest('.shopify-section');
      if (!section || !section.closest('main, footer')) return;
      prepareSection(section);
    });
  }

  function boot() {
    try {
      init();
    } catch (error) {
      forceRevealPending();
      if (window.console && console.warn) {
        console.warn('[reveal-animation] disabled due to error:', error);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
